export default __webpack_public_path__ + "static/media/single-project-page-04-img16.6612660a.jpg";